// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__TL_JN","spindindust":"Loading_spindindust__267Xi","blue":"Loading_blue__1AZYR","cover":"Loading_cover__NZOqw"};